import React, {FC} from "react";
import Typography from "@mui/material/Typography";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material";

interface IProps {
    title: string,
    sx?: SxProps<Theme>
    alwaysCenter?: boolean
    alwaysLeft?: boolean
}

const PageTitle: FC<IProps> = (props) => {
    return (
        <Typography variant='h3' fontWeight="bold" color="primary"
                    sx={{
                        textAlign: {xs: 'center', sm: !props.alwaysCenter ? 'left' : 'center'},
                        width: {xs: '100%', sm: 'auto'},
                        fontSize: {xs: '2rem', sm: '2.3rem'},
                        ...props.sx,
                    }}>
            {props.title}
        </Typography>
    )
}

export default PageTitle